var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty_data_container"},[_c('div',[(_vm.type==3)?_c('img',{staticClass:"img_delete",attrs:{"src":_vm.imgDelete,"alt":""}}):_vm._e(),(_vm.type==2)?_c('img',{staticClass:"img_off",attrs:{"src":_vm.imgOff,"alt":""}}):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }